import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { IOrigins } from "interfaces";

const { Title, Text } = Typography;

export const OriginsShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IOrigins>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Descrição</Title>
      <Text>{record?.Description}</Text>

      <Title level={5}>Tag</Title>
      <Text>{record?.Tag}</Text>
    </Show>
  );
};
